import { authorizedAxios } from 'library/axios/apiProvider';
import { InsuranceFormState } from 'pages/AgentRemoteSale/components/InsuranceBox/types';

export async function chooseInsurance(id: string): Promise<InsuranceFormState> {
  const { data } = await authorizedAxios().post(`/api/v1/offer-client/set-chosen/`, { id });
  return data;
}
